import { useRef, useState, useEffect } from "react";
import EditorJS from "@editorjs/editorjs";
import Header from '@editorjs/header';
import Paragraph from '@editorjs/paragraph';
import Link from '@editorjs/link';
import List from '@editorjs/list';
import Delimiter from '@editorjs/delimiter';
import SimpleImage from '@editorjs/simple-image';
import Quote from '@editorjs/quote';
import Table from '@editorjs/table';
import CardCollapsible from "./CardCollapsible";
import JSDisplayValue from "./JSDisplayValue";
// const SimpleImage = require('simple-image-editorjs'); // FORK
// import SimpleImage from 'simple-image-editorjs'; // FORK
// import Blocks from 'editorjs-blocks-react-renderer';
import FrfrAlienEditorjsRendererV1 from "./FrfrAlienEditorjsRendererV1";


// https://dev.to/sumankalia/how-to-integrate-editorjs-in-reactjs-2l6l
// https://medium.com/how-to-react/how-to-add-wysiwyg-editor-in-react-js-using-editor-js-cff90e2f3b75


//
/*
export const EDITOR_JS_TOOLS = {
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
  },
  checkList: CheckList,
  list: List,
  header: Header,
  delimiter: Delimiter,
  link: Link,
};
*/
export const EDITOR_JS_TOOLS = {
  paragraph: {
    class: Paragraph,
    inlineToolbar: true,
  },
  // checkList: CheckList,
  header: Header, // there is no inlineToolbar
  link: Link, // there is no inlineToolbar
  // list: List,
  list: {
    class: List,
    inlineToolbar: true,
    config: {
      defaultStyle: 'unordered'
    },
  },
  delimiter: Delimiter, // there is no inlineToolbar
  // quote: Quote,
  quote: {
    class: Quote,
    inlineToolbar: true,
    // shortcut: 'CMD+SHIFT+O',
    config: {
      quotePlaceholder: 'Enter a quote',
      captionPlaceholder: 'Quote\'s author',
    },
  },
  /*
  tools: {
    table: Table,
  },
  */
  table: {
    class: Table,
    inlineToolbar: true,
    config: {
      rows: 2,
      cols: 3,
      // maxRows: 5,
      // maxCols: 5,
    },
  },
  // image: SimpleImage,
  // Add the SimpleImage tool here
  /*
  simpleImage: {
    class: SimpleImage,
    inlineToolbar: true,
    config: {
      placeholder: 'Paste image URL'
    }
  },
  */
  /*
  image: {
    class: SimpleImage,
    inlineToolbar: ['link'],
  },
  */
  image: {
    class: SimpleImage,
    inlineToolbar: true,
    config: {
      placeholder: 'Paste image URL'
    }
  }
};


//
const DEFAULT_INITIAL_DATA = {
  "time": new Date().getTime(),
  "blocks": [
    {
      "type": "header",
      "data": {
        "text": "This is my awesome editor!",
        "level": 1
      }
    },
    {
      id: "image-block-id",
      // type: "simpleImage",
      type: "image",
      data: {
        // url: "https://example.com/images/some-image.jpg",
        url: "https://editorjs.io/_nuxt/editor-2.9f872826.jpg",
        caption: "Optional caption",
        stretched: false,
        withBackground: false,
        withBorder: false,
      },
    },
  ]
}

//
const YourmapEditorjsDemoV1 = (props) => {
  // const ejInstance = useRef();
  const ejInstance = useRef(null);

  // State to store the saved data
  const [savedData, setSavedData] = useState(null);

  const initEditor = () => {
    console.log('++ initEditor');
    const editor = new EditorJS({
      holder: 'editorjs',
      onReady: () => {
        ejInstance.current = editor;
      },
      autofocus: true,
      data: DEFAULT_INITIAL_DATA,
      onChange: async () => {
        let content = await editor.saver.save();
        console.log(content);

        //
        setSavedData(content); // Update React state with new data
      },
      /*
      tools: {
        header: Header,
      },
      */
      tools: EDITOR_JS_TOOLS,
    });
  };

  // To make sure the editor load only once we have to add this condition in “useEffect”.
  // And we will destroy the instance while the component unmounts.
  useEffect(() => {
    // componentDidMount
    console.log('++ useEffect');
    if (ejInstance.current === null) {
      initEditor();
    }
    // componentWillUnmount
    return () => {
      ejInstance?.current?.destroy();
      ejInstance.current = null;
    };
  }, []);

  const editorjs_renderable_data = savedData;

  return (
    <div className="yourmap__editorjs unirole-scope-without-default-transition">
      <div>
        Eeditor.js DEMO:
      </div>
      <div>
        <><div id='editorjs'></div></>
      </div>
      <div>
        <CardCollapsible title='* DEBUG state'>
          <JSDisplayValue val={savedData} />
        </CardCollapsible>
      </div>
      <div className="uu-gap-standalone-1rem"></div>
      <div>
        <CardCollapsible jsxHeader={<><b>Render</b> preview:</>}>
          <>
            <FrfrAlienEditorjsRendererV1 editorjs_renderable_data={editorjs_renderable_data} />
          </>
        </CardCollapsible>
      </div>
    </div>
  );
};

export default YourmapEditorjsDemoV1;